import openSearchFilters from '../property/search-popup';
import initMobileFilters from '../search/mobile-filters';

class NewsPage {
    constructor() {
        const newsSearchForm = document.querySelector<HTMLFormElement>( '#search-form-base' );

        if ( newsSearchForm ) {
            initMobileFilters( newsSearchForm );

            const autoTriggerSubmitSelects = newsSearchForm.querySelectorAll( '[name=section],[name=radius],[name=order]' );

            for ( let i = 0; i < autoTriggerSubmitSelects.length; i++ ) {
                autoTriggerSubmitSelects[ i ].addEventListener( 'change', function() {
                    newsSearchForm.submit();
                } );
            }

            const newsOrderByInput = newsSearchForm.querySelector<HTMLInputElement>( '[name="order"]' );
            const newsSearchOrderBy = document.querySelector<HTMLSelectElement>( '#search-orderby' );

            if ( newsSearchOrderBy && newsOrderByInput ) {
                newsSearchOrderBy.addEventListener( 'change', function( event: Event ) {
                    event.preventDefault();
                    newsOrderByInput.value = newsSearchOrderBy.value;
                    newsSearchForm.submit();
                } );
            }
        }

        document.querySelectorAll( 'button[data-action="open-search-filters"]' ).forEach( ( btn: HTMLButtonElement ) => {
            btn.addEventListener( 'click', () => {
                window.router.CaptureThen( openSearchFilters );
            } );

            btn.dataset.initialised = 'true';
        } );
    }
}

if ( !window.newspage ) {
    window.newspage = new NewsPage();
}
